/**
 * AF shared carousel arrow nav (desktop)
 * Namespace: window.AfArrowNav
 *
 * Created: 2026-08-14 18:12 IST
 * Author: Cursor Agent
 * Reason: Center-left / center-right Prev/Next for Hero + card carousels
 */
(function () {
  'use strict';

  var PREV_SVG =
    '<span class="af-arrow-nav__icon" aria-hidden="true">' +
    '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M12.5 4.5L7 10l5.5 5.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

  var NEXT_SVG =
    '<span class="af-arrow-nav__icon" aria-hidden="true">' +
    '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M7.5 4.5L13 10l-5.5 5.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

  function create(host, options) {
    options = options || {};
    if (!host) return null;

    var style = window.getComputedStyle(host);
    if (style.position === 'static') {
      host.style.position = 'relative';
    }

    var nav = document.createElement('div');
    nav.className = 'af-arrow-nav';
    nav.setAttribute('data-af-arrow-nav', '');
    nav.setAttribute('aria-hidden', 'true');

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'af-arrow-nav__btn af-arrow-nav__btn--prev';
    prevBtn.setAttribute('aria-label', options.prevLabel || 'Previous');
    prevBtn.innerHTML = PREV_SVG;

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'af-arrow-nav__btn af-arrow-nav__btn--next';
    nextBtn.setAttribute('aria-label', options.nextLabel || 'Next');
    nextBtn.innerHTML = NEXT_SVG;

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (prevBtn.disabled) return;
      if (typeof options.onPrev === 'function') options.onPrev();
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (nextBtn.disabled) return;
      if (typeof options.onNext === 'function') options.onNext();
    });

    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);
    host.appendChild(nav);

    function setEnabled(enabled) {
      nav.classList.toggle('is-enabled', !!enabled);
      nav.setAttribute('aria-hidden', enabled ? 'false' : 'true');
    }

    function setDisabled(prevDisabled, nextDisabled) {
      prevBtn.disabled = !!prevDisabled;
      nextBtn.disabled = !!nextDisabled;
    }

    function syncFromScroller(scroller) {
      if (!scroller) {
        setEnabled(false);
        return;
      }
      var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      var canScroll = maxScroll > 4;
      setEnabled(canScroll);
      if (!canScroll) {
        setDisabled(true, true);
        return;
      }
      var sl = scroller.scrollLeft;
      setDisabled(sl <= 4, sl >= maxScroll - 4);
    }

    setEnabled(false);

    return {
      el: nav,
      setEnabled: setEnabled,
      setDisabled: setDisabled,
      syncFromScroller: syncFromScroller,
      destroy: function () {
        if (nav.parentNode) nav.parentNode.removeChild(nav);
      }
    };
  }

  window.AfArrowNav = {
    create: create
  };
})();
